import { render, staticRenderFns } from "./TeamMembersPage.vue?vue&type=template&id=5a7310c2&scoped=true&lang=html&"
import script from "./TeamMembersPage.vue?vue&type=script&lang=js&"
export * from "./TeamMembersPage.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembersPage.vue?vue&type=style&index=0&id=5a7310c2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7310c2",
  null
  
)

export default component.exports